import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';
import { handleError } from '../../utils/handleError';
import logger from '../../utils/logger.utils';

const initialState = {
	isLoading: false,
	error: null,
	items: [],
	pagination: { page: 1, limit: 10, total: 0, pages: 0 },
	current: null,
};

export const fetchUploadAttempts = createAsyncThunk(
	'uploadAttempts/fetchAll',
	async ({ page = 1, limit = 10, status = '', q = '', email = '', from = '', to = '' } = {}, { rejectWithValue }) => {
		try {
			const params = new URLSearchParams({ page, limit });
			if (status) params.append('status', status);
			if (q) params.append('q', q);
			if (email) params.append('email', email);
			if (from) params.append('from', from);
			if (to) params.append('to', to);

			const res = await axiosInstance.get(`/admin/uploads-attempts/attempts?${params.toString()}`);
			logger.log('Fetched upload attempts:', res.data);
			return res.data;
		} catch (err) {
			return rejectWithValue(handleError(err));
		}
	}
);
export const deleteUploadAttempts = createAsyncThunk(
	'uploadAttempts/delete',
	async (ids = [], { rejectWithValue }) => {
		try {
			const res = await axiosInstance.delete(`/admin/uploads-attempts/attempts/bulk`, { data: { ids } });
			return res.data;
		}	catch (err) {
			return rejectWithValue(handleError(err));
		}
	})

export const fetchUploadAttemptById = createAsyncThunk(
	'uploadAttempts/fetchOne',
	async (id, { rejectWithValue }) => {
		try {
			const res = await axiosInstance.get(`/admin/uploads-attempts/attempts/${id}`);
			return res.data;
		} catch (err) {
			return rejectWithValue(handleError(err));
		}
	}
);

const slice = createSlice({
	name: 'uploadAttempts',
	initialState,
	reducers: {
		clearAttemptError: (state) => { state.error = null; },
		clearAttemptCurrent: (state) => { state.current = null; },
	},
	extraReducers: (builder) => {
		builder
		.addCase(fetchUploadAttempts.pending, (state) => { state.isLoading = true; state.error = null; })
		.addCase(fetchUploadAttempts.fulfilled, (state, action) => {
			state.isLoading = false;
			state.items = action.payload?.items || [];
			state.pagination = {
			page: action.payload?.page || 1,
			limit: action.payload?.limit || 10,
			total: action.payload?.total || 0,
			pages: action.payload?.pages || 0,
			};
		})
		.addCase(deleteUploadAttempts.pending, (state) => { state.isLoading = true; state.error = null; })
		.addCase(deleteUploadAttempts.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload?.message || 'Unable to delete attempts.';
		})
		.addCase(deleteUploadAttempts.fulfilled, (state, action) => {
			state.isLoading = false;
		})
		.addCase(fetchUploadAttempts.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload?.message || 'Unable to fetch attempts.';
		})
		.addCase(fetchUploadAttemptById.pending, (state) => { state.error = null; })
		.addCase(fetchUploadAttemptById.fulfilled, (state, action) => {
			state.current = action.payload?.item || null;
		})
		.addCase(fetchUploadAttemptById.rejected, (state, action) => {
			state.error = action.payload?.message || 'Unable to fetch attempt.';
		});
	},
});

export const { clearAttemptError, clearAttemptCurrent } = slice.actions;
export default slice.reducer;